import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { ApiEcoState } from '../../store/api-eco.state';
import { BannerService } from '../../services/banner.service';

export interface BannerData {
  _id?: string;
  id?: string;
  bannerText: string;
  bannerType: string;
  bannerLocation?: string;
  bannerFileName?: string;
}

@Component({
  selector: 'kp-global-banner',
  templateUrl: './global-banner.component.html',
  styleUrls: ['./global-banner.component.scss'],
})
export class GlobalBannerComponent implements OnInit {
  @Output() hideGlobalBanner = new EventEmitter<boolean>();
  bannerData: BannerData;
  hideBanner = this.bannerService.hideBanner;
  constructor(
    private bannerService: BannerService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.select(ApiEcoState.getBanner).subscribe(bannerData => {
      if (bannerData) {
        // bannerData is now a single object, not an array
        this.bannerData = Array.isArray(bannerData) ? bannerData[0] : bannerData;
      } else {
        this.bannerData = null;
      }
    });
  }

  setHideBanner(value: boolean) {
    this.hideBanner = value;
    this.bannerService.hideBanner = value;
  }

  onBannerFileClick(event: Event, id: string, fileName?: string) {
    event.preventDefault();
    if (!id) {
      return;
    }
    this.bannerService.getFileStream(id).subscribe(blob => {
      if (!blob) {
        return;
      }
      const url = URL.createObjectURL(blob);
      if (this.isPdf(fileName)) {
        window.open(url, '_blank', 'noopener,noreferrer');
        // Let the browser render the PDF; revoke shortly after.
        setTimeout(() => URL.revokeObjectURL(url), 30000);
      } else {
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName || 'download';
        a.click();
        URL.revokeObjectURL(url);
      }
    });
  }

  isPdf(name?: string): boolean {
    return !!name && name.toLowerCase().endsWith('.pdf');
  }
}
